export default __webpack_public_path__ + "social-proof-categories-section.png";